import Footer from "app/pages/.shared/Footer/Footer";

/* eslint-disable react/prop-types */
const BrandFooter = props => <Footer {...props} />;
export default BrandFooter;
